import LoaderWrapper from 'Common/LoaderWrapper/LoaderWrapper';
import api from 'http';
import React, { useEffect, useState } from 'react'
import { ErrorHandlingMessage } from 'Utils/ErrorHandlingMessage';
import { FiAlertCircle, FiChevronDown } from 'react-icons/fi';
import * as RadixDropdownMenu from "@radix-ui/react-dropdown-menu";
const StripeAccountInput = ({ stripeSettingsId, patientPaymentType, handleStripeAccount, validationModel }) => {
    const [stripeAccounts, setStripeAccounts] = useState([]);
    const [stripeLoader, setStripeLoader] = useState(false);
    const [isOpen, setIsOpen] = useState(false);

    useEffect(() => {
        (async () => {
            try {
                setStripeLoader(true);
                const res = await api.get(`${process.env.REACT_APP_TC_PMS}/api/StripeSettings/FindStripeSettings`);

                setStripeAccounts(res.data.dataModel);
                if (res.data.dataModel?.length > 0) {
                    if (res.data.dataModel?.length === 1) {
                        const account = res.data.dataModel[0];
                        handleStripeAccount(account.id, account.p_Key);
                    }
                }
            } catch (err) {
                ErrorHandlingMessage(err);
                setStripeAccounts([]);
            } finally {
                setStripeLoader(false);
            }
        })();
    }, [handleStripeAccount])


    // Open dropdown when paymentModel.patientPaymentType changes
    useEffect(() => {
        if (patientPaymentType && !stripeLoader && !stripeSettingsId) {
            setIsOpen(true);
        }

    }, [patientPaymentType, stripeLoader, stripeSettingsId])

    const handleSelect = (account) => {
        handleStripeAccount(account.id, account.p_Key);
        setIsOpen(false);
    }

    return (
        <div>
            <label className="block mb-2 text-sm font-medium required text-slate-700">Stripe Account</label>
            <LoaderWrapper loading={stripeLoader} className="h-[38px]">
                <RadixDropdownMenu.Root open={isOpen} onOpenChange={setIsOpen}>
                    <RadixDropdownMenu.Trigger asChild>
                        <button
                            disabled={stripeLoader}
                            className={`customInputClass border   h-9 w-full text-left flex items-center justify-between pr-2 cursor-pointer${isOpen ? 'border border-primary rounded' : ''} ${stripeLoader ? 'cursor-not-allowed opacity-50' : ''}`}
                        >
                            <span className={stripeSettingsId ? 'text-gray-900' : 'text-gray-400'}>
                                {stripeSettingsId ? stripeAccounts.find(acc => acc.id === stripeSettingsId)?.stripeAccount : 'Please Select'}
                            </span>
                            <FiChevronDown size={16} className={`  text-gray-900 transition-transform  `} />
                        </button>
                    </RadixDropdownMenu.Trigger>

                    <RadixDropdownMenu.Portal>
                        <RadixDropdownMenu.Content
                            className="min-w-[var(--radix-dropdown-menu-trigger-width)] z-50 bg-white border border-gray-200 rounded shadow-lg max-h-60 overflow-auto"
                            sideOffset={5}
                            align="start"
                        >
                            <RadixDropdownMenu.Item
                                key="Please Select"
                                onSelect={() => handleSelect(stripeAccounts[0])}
                                className={`px-3 py-2 cursor-pointer hover:bg-gray-100 border-b border-gray-200 ${stripeSettingsId === "Please Select" ? 'bg-primaryColor/10 text-primaryColor font-medium' : 'text-gray-900'
                                    }`}
                            >
                                Please Select
                            </RadixDropdownMenu.Item>
                            {stripeAccounts.map((account) => (
                                <RadixDropdownMenu.Item
                                    key={account.p_Key}
                                    onSelect={() => handleSelect(account)}
                                    className={`px-3 py-2 cursor-pointer hover:bg-gray-100 border-b border-gray-200 ${stripeSettingsId === account.id ? 'bg-primaryColor/10 text-primaryColor font-medium' : 'text-gray-900'
                                        }`}
                                >
                                    {account.stripeAccount}
                                </RadixDropdownMenu.Item>
                            ))}
                        </RadixDropdownMenu.Content>
                    </RadixDropdownMenu.Portal>
                </RadixDropdownMenu.Root>


                {validationModel.stripeSettingsIdError && (
                    <div className="flex items-center gap-2 p-3 mt-2 border border-red-200 rounded-lg bg-red-50">
                        <FiAlertCircle className="flex-shrink-0 w-4 h-4 text-red-600" />
                        <span className="text-sm text-red-700">
                            {validationModel.stripeSettingsIdError}
                        </span>
                    </div>
                )}
            </LoaderWrapper>
        </div>
    )
}

export default React.memo(StripeAccountInput)